module.exports = __webpack_public_path__ + "529affff5acda32d81c43e39649a0eb7.MP3";